import { makeNamespacedComponent } from '@/ui/utils';
import { Button, Group } from './atoms';

const RadioGroup = makeNamespacedComponent(Group, {
  Button,
});

export { RadioGroup };
